<template>
  <page-section :title="slider.title" class="post-slider-wrapper !pr-0">
    <posts-slider v-if="posts.length" class="post-slider" :posts="posts" />
  </page-section>
</template>
<script setup lang="ts">
import type { StrapiPostSlider } from "~/types/strapi";
import PostsSlider from "~/modules/blog/components/PostsSlider.vue";
import type { CmsPage } from "~/types/strapi/collection-types/CmsPage";

const props = defineProps<{ slider: StrapiPostSlider }>();
const posts = computed<CmsPage[]>(
  () => props.slider?.postSlider?.data?.map((page) => page.attributes) ?? [],
);
</script>

<style scoped lang="scss">
.post-slider {
  &:deep(.posts-slider__navigations) {
    @apply absolute right-4 top-8 sm:right-5 sm:top-7 lg:right-10 lg:top-[72px];
  }
  &:deep(.posts-slider__navigations-wrapper) {
    @apply flex justify-end;
  }
  &-wrapper {
    @apply relative;

    &:deep(.page-section-top) {
      @apply pb-8 sm:pb-7 sm:pt-10 lg:pb-10 lg:pt-[72px];
    }
  }
}
</style>
